import { api } from './axios';
import { ContactEntity } from '../interfaces/contacts';
import { useContactStore } from '@/stores/contact.store';

const getContact = async (): Promise<ContactEntity> => {
  const contactsQuery = `query getContact { 
    contactList { 
      nodes { 
        email 
        id 
        address
        isActive 
        phone 
      } 
    } 
  }`;

  const event = await api
    .post('', {
      query: contactsQuery,
      operationName: 'getContact'
    })
    .then((res) =>
      res.data.data.contactList.nodes.find(
        (item: ContactEntity) => item.isActive
      )
    )
    .catch((error) => {
      if (error.code === 'ECONNABORTED') {
        return getContact();
      }
    });

  return event as ContactEntity;
};

const initializeContacts = () => {
  const contactStore = useContactStore();

  getContact().then((res) => {
    contactStore.setContact(res);
  });
};

export { initializeContacts };
